const getFullDate = date => {
  if (!date) {
    return null
  }

  const instanceDate = new Date(date)
  const day = instanceDate.getDate()
  const month = instanceDate.getMonth() + 1
  const hour = instanceDate.getHours()
  const minute = instanceDate.getMinutes()
  let formatedDay = day.toString()
  let formatedMonth = month.toString()
  let formatedHour = hour.toString()
  let formatedMinute = minute.toString()

  if (formatedDay.length < 2) {
    formatedDay = `0${formatedDay}`
  }
  if (formatedMonth.length < 2) {
    formatedMonth = `0${formatedMonth}`
  }
  if (formatedHour.length < 2) {
    formatedHour = `0${formatedHour}`
  }
  if (formatedMinute.length < 2) {
    formatedMinute = `0${formatedMinute}`
  }

  return `${formatedDay}.${formatedMonth}, ${formatedHour}:${formatedMinute}`
}

export default getFullDate
